import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Shield, Award, Users, CheckCircle2, Lock, Star, Globe, Clock } from 'lucide-react';

export const TrustBadgesSection = () => {
  return (
    <section className="py-12 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8">
          <Badge variant="secondary" className="mb-3">
            Trusted Worldwide
          </Badge>
          <h2 className="text-2xl md:text-3xl font-bold mb-3">
            Why 100,000+ People Trust Us
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Your safety, privacy, and satisfaction are our top priorities
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {/* Verification Badge */}
          <Card className="border-2 hover:border-primary/50 transition-all hover:shadow-lg">
            <CardContent className="p-6 text-center">
              <div className="mb-3 flex justify-center">
                <div className="bg-primary/10 p-3 rounded-full">
                  <Award className="h-8 w-8 text-primary" />
                </div>
              </div>
              <h3 className="font-bold mb-2">Dr. Marín Certified</h3>
              <p className="text-xs text-muted-foreground">
                All therapists trained by Dr. José Luis Marín
              </p>
            </CardContent>
          </Card>

          {/* Privacy Badge */}
          <Card className="border-2 hover:border-primary/50 transition-all hover:shadow-lg">
            <CardContent className="p-6 text-center">
              <div className="mb-3 flex justify-center">
                <div className="bg-green-50 p-3 rounded-full">
                  <Lock className="h-8 w-8 text-green-600" />
                </div>
              </div>
              <h3 className="font-bold mb-2">100% Confidential</h3>
              <p className="text-xs text-muted-foreground">
                HIPAA compliant & end-to-end encrypted
              </p>
            </CardContent>
          </Card>

          {/* Rating Badge */}
          <Card className="border-2 hover:border-primary/50 transition-all hover:shadow-lg">
            <CardContent className="p-6 text-center">
              <div className="mb-3 flex justify-center">
                <div className="bg-yellow-50 p-3 rounded-full">
                  <Star className="h-8 w-8 text-yellow-500 fill-yellow-500" />
                </div>
              </div>
              <h3 className="font-bold mb-2">4.8/5 Rating</h3>
              <p className="text-xs text-muted-foreground">
                From 5,000+ verified reviews
              </p>
            </CardContent>
          </Card>

          {/* Users Badge */}
          <Card className="border-2 hover:border-primary/50 transition-all hover:shadow-lg">
            <CardContent className="p-6 text-center">
              <div className="mb-3 flex justify-center">
                <div className="bg-blue-50 p-3 rounded-full">
                  <Users className="h-8 w-8 text-blue-600" />
                </div>
              </div>
              <h3 className="font-bold mb-2">100K+ Sessions</h3>
              <p className="text-xs text-muted-foreground">
                Successfully completed worldwide
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Additional Trust Signals */}
        <div className="mt-8 flex flex-wrap justify-center gap-6 items-center">
          <div className="flex items-center gap-2 text-sm">
            <CheckCircle2 className="h-5 w-5 text-green-600" />
            <span className="font-medium">Money-back guarantee</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Globe className="h-5 w-5 text-blue-600" />
            <span className="font-medium">150+ countries</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Clock className="h-5 w-5 text-orange-600" />
            <span className="font-medium">24/7 support</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Shield className="h-5 w-5 text-purple-600" />
            <span className="font-medium">SSL secured</span>
          </div>
        </div>

        {/* Accreditation Logos Placeholder */}
        <div className="mt-8 pt-8 border-t">
          <p className="text-center text-sm text-muted-foreground mb-4">
            Recognized by leading healthcare organizations
          </p>
          <div className="flex flex-wrap justify-center gap-8 items-center opacity-60">
            {/* Placeholder for actual accreditation logos */}
            <div className="bg-muted rounded-lg px-6 py-3 text-xs font-semibold">
              APA Approved
            </div>
            <div className="bg-muted rounded-lg px-6 py-3 text-xs font-semibold">
              HIPAA Compliant
            </div>
            <div className="bg-muted rounded-lg px-6 py-3 text-xs font-semibold">
              ISO Certified
            </div>
            <div className="bg-muted rounded-lg px-6 py-3 text-xs font-semibold">
              BBB Accredited
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
